<template>
  <div id="footer_zh">
    <div class="bottom">
      <div class="app">
        <div>
          <span class="size">
            <img class="img" src="../assets/image/htsh.png" alt="海獭生活" />
          </span>

          <p>{{$t('promote.footer0')}}</p>
        </div>
        <div>
          <span class="size">
            <img class="img" src="../assets/image/wxsm.png" alt="微信扫码" />
          </span>

          <p>{{$t('promote.footer1')}}</p>
        </div>
        <div>
          <span class="size">
            <img class="img" src="../assets/image/htsy.png" alt="海獭收银" />
          </span>

          <p>{{$t('promote.footer2')}}</p>
        </div>
        <div>
          <span class="size">
            <img class="img" src="../assets/image/retail.png" alt="海獭零售" />
          </span>

          <p>{{$t('promote.footer3')}}</p>
        </div>
      </div>
      <div class="contactInformation">
        <h3>{{$t('promote.footer4')}}</h3>
        <div class="service">
          <p>{{$t('promote.footer5')}}：092-6862875、 062-5626123</p>
          <p>( {{$t('promote.footer6')}} 09:00-18:00 )</p>
          <p>LINE: 7428163</p>
          <p>E-mail: sales@haitalife.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "footerZh",
  data() {
    return {
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    }
  },
    methods: {
    ...mapMutations({
      get_lang: "get_lang" 
    }),
    }
};
</script>


<style lang="less">
#footer_zh {
  color: #fff;
  a {
    text-decoration: none;
    color: #fff;
  }
  .bottom {
    width: 100%;
    height: auto;
    background: rgba(25, 24, 23, 1);
    padding: 30px 0;
    .app {
      color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      padding:0 40px;
      box-sizing: border-box;
    
      .size {
        margin: 0 auto;
        display: block;
        width: 42px;
        height:42px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        font-size: 11px;
        font-family: PingFangSC-Medium;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin: 8px 0 14px 0;
      }
    }
    .contactInformation {
      width: 100%;
      margin: 0 auto;
      padding:0 40px;
      box-sizing: border-box;
      h3 {
        // margin: 15px 0 10px 0;
        font-size: 16px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 40px;
      }
      p {
        margin:5px 0;
      }
      .service {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
